import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

type UseCompetitionResultListQueryParams = Parameters<typeof SSF.api.resultsList>[0];

export const keys = createQueryKeySet<UseCompetitionResultListQueryParams>('competitions.results');

export function useCompetitionResultListQuery(params?: UseCompetitionResultListQueryParams, enabled = true) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.resultsList(params);
      return data;
    },
    queryKey: keys.list(params),
    enabled,
  });
}

export function useCompetitionResultQuery(id?: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.resultsRetrieve(id!);
      return data;
    },
    queryKey: keys.detail(id!),
    enabled: !!id,
  });
}
